import { ValidationError } from 'yup';
import type { StringSchema } from 'yup';

import { clientRequestSchemasForm } from './clientRequestSchemas';

export const clientRequestTitleSchema = clientRequestSchemasForm.fields
  .title as StringSchema<string>;

export const validateClientRequestTitle = (value: string) => {
  try {
    return {
      error: null,
      title: clientRequestTitleSchema.validateSync(value),
    };
  } catch (error) {
    if (error instanceof ValidationError) {
      return {
        error: error.message,
        title: value.trim(),
      };
    }

    throw error;
  }
};
